import { createFileRoute } from '@tanstack/react-router';

import { ProviderInvitationsPage } from '@/features/services/provider/invitations-page';

export const Route = createFileRoute('/_app/me/services/invitations')({
  component: ProviderInvitationsPage,
});
